import React from 'react';
import MainLayout from '../../layouts/MainLayout';
import DataVisualizationV2 from '../dashboard/DataVisualizationComponentV2';

function DataVisualizationView() {
  return (
    <MainLayout>
      <DataVisualizationV2 />
    </MainLayout>
  );
}

export default DataVisualizationView;
